import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./contexts/LanguageContext";

function App({ Router = BrowserRouter, routerProps = {} }) {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <LanguageProvider>
        <Router {...routerProps}>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </Router>
        <Toaster />
      </LanguageProvider>
    </div>
  );
}

export default App;
